module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNTAwIiBoZWlnaHQ9IjkwMCIgdmlld0JveD0iMCAwIDE1MCA5MCI+PHBhdGggZD0iTTAgMGgxNTB2OTBIMCIgZmlsbD0iI2ZmZiIvPjxwYXRoIGZpbGw9IiNjZTExMjYiIGQ9Ik0xNTAgMEgzN2wyMyA5LTIzIDkgMjMgOS0yMyA5IDIzIDktMjMgOSAyMyA5LTIzIDkgMjMgOS0yMyA5aDExMyIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/bhr.svg
// module id = Hnpc
// module chunks = 0